module.exports = __webpack_public_path__ + "img/保険証.75070543.png";